import { computed } from 'vue';
import {
  DEVICE_STATUS_ACTIVE,
  DEVICE_STATUS_TABS,
} from '@/config/device-status-tabs';
import {
  useTrackersListStatusStore,
  type TrackerListStatusContext,
} from '@/stores/useTrackersListStatusStore';

export function useDeviceStatusTabs(
  context: TrackerListStatusContext = 'trackers',
) {
  const statusStore = useTrackersListStatusStore();

  const selectedStatuses = computed({
    get: () => {
      const statuses = statusStore.getSelectedStatuses(context);
      return statuses.length ? statuses : [DEVICE_STATUS_ACTIVE];
    },
    set: (statuses: string[]) => {
      statusStore.setSelectedStatuses(context, statuses);
    },
  });

  return {
    tabs: DEVICE_STATUS_TABS,
    selectedStatuses,
  };
}
